import { reactive, ref } from 'vue'

export const useBobProPage = () => {
  const bobProPageRef = ref(null)
  const modal = reactive({
    delete: false,
    edit: false,
    detail: false,
    create: false,
  })
  const selectRow = ref(null)
  const editAction = ref('create')

  const onRefresh = () => {
    bobProPageRef.value?.refresh()
  }

  const onCloseModal = (type) => {
    modal[type] = false
    selectRow.value = null
  }

  return {
    bobProPageRef,
    modal,
    selectRow,
    editAction,
    onRefresh,
    onCloseModal,
  }
}
